export enum Column {
  PACKAGE_NAME = 0,
  PACKAGE_TYPE = 1,
  LANGUAGE = 2,
  DESCRIPTION = 3,
  COMPANY = 4,
}

export enum ColumnKeys {
  PACKAGE_NAME = 'name',
  PACKAGE_TYPE = 'type',
  LANGUAGE = 'language',
  DESCRIPTION = 'description',
  COMPANY = 'company.name',
}
